import React from 'react';

function ListPageHeader({ kicker, kickerIcon: KickerIcon, title, description, actions }) {
  return (
    <header className="ux-list-header">
      <div className="ux-list-header-main">
        {kicker && (
          <div className="ux-list-kicker">
            {KickerIcon && <KickerIcon size={16} />}
            <span>{kicker}</span>
          </div>
        )}
        <h1 className="ux-list-title">{title}</h1>
        {description && <p className="ux-list-desc">{description}</p>}
      </div>
      {actions && <div className="ux-list-header-actions">{actions}</div>}
    </header>
  );
}

export default ListPageHeader;
